//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { useRightsHistoricalUrlsQuery } from '@uia/rights/hooks/useRightsHistoricalUrlsQuery';
import { isDefined } from '@utils/filterPredicates';

export const useRightsRequestTCUrl = () => {
  const { data: historicalUrls } = useRightsHistoricalUrlsQuery();
  const hasAtLeastOneUrl =
    isDefined(historicalUrls) && historicalUrls.length > 0;

  return hasAtLeastOneUrl
    ? historicalUrls[0]?.termsAndConditionsUrl
    : undefined;
};
